
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import Project from "./DonationProjectView.vue"; // @ is an alias to /src
import {
    MyDonnitonAndSupplies,
    MyDonnitonAndSuppliesLst,
} from "@/api/donationApi";

export default defineComponent({
    setup() {
        const router = useRouter();

        return {
            ///0 全部 1 捐款心愿 2 捐赠物资
            donntionType: router.currentRoute.value.query.donntionType || 0,
            router, //一定要要放在return里才能在模板上面使用
        };
    },

    activated() {
        this.myInfo();
        if (this.$refs.appList) {
            this.$refs.appList.refresh();
        }
    },
    methods: {
        async Search({ index, setData }) {
            var datainfo = await MyDonnitonAndSuppliesLst(
                this.donntionType,
                index,
                this.pageSize
            );
            this.totacount = datainfo.total;
            const arr = datainfo.rows;
            setData(arr, this.totacount);
        },
        async myInfo() {
            var info = await MyDonnitonAndSupplies();
            this.donnitonCount = info.donnitonCount;
            this.suppliesCount = info.suppliesCount;
            this.totalPoints = info.totalPoints;
        },
        setDonnationParm(type) {
            this.donntionType = type;
            if (this.$refs.appList) {
                this.$refs.appList.refresh();
            }
        },
    },
    name: "GyMyDonationProject",
    components: { Project },
    data() {
        return {
            pageSize: 20,
            dataTotalCount: 0,
            donnitonCount: 0,
            suppliesCount: 0,
            totalPoints: 0,
            totacount: 0,
        };
    },
});
